"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var trackLoaderDependencies_exports = {};
__export(trackLoaderDependencies_exports, {
  trackLoaderDependencies: () => trackLoaderDependencies
});
module.exports = __toCommonJS(trackLoaderDependencies_exports);
var import_async_hooks = require("async_hooks");
var import_watchFile = require("./watchFile");
var LOADER_DEPS_KEY = "__oneLoaderDepsContext";
var LOADER_DEPS_STORE = {
  get current() {
    if (globalThis[LOADER_DEPS_KEY]) return globalThis[LOADER_DEPS_KEY];
    var als = new import_async_hooks.AsyncLocalStorage();
    globalThis[LOADER_DEPS_KEY] = als;
    return als;
  }
};
var debugLoaderDeps = process.env.ONE_DEBUG_LOADER_DEPS;
function watchFileImpl(path) {
  var store = LOADER_DEPS_STORE.current.getStore();
  if (store) {
    store.deps.add(path);
  }
}
(0, import_watchFile._registerWatchFileImpl)(watchFileImpl);
async function trackLoaderDependencies(fn) {
  var deps = /* @__PURE__ */ new Set();
  var context = LOADER_DEPS_STORE.current;
  var result = await context.run({
    deps
  }, async function() {
    return await fn();
  });
  if (debugLoaderDeps && deps.size > 0) {
    console.info("[loader-deps] tracked dependencies:", [
      ...deps
    ]);
  }
  return {
    result,
    dependencies: deps
  };
}
//# sourceMappingURL=trackLoaderDependencies.js.map
